import React from "react";
import "../../styles/Productdetailed.css";
import lauhBhasma from "../../assets/ingridients-images/stamina/lauh-bhasma.png";
import mandurBhasma from "../../assets/ingridients-images/stamina/mandur-bhasma.png";
import abhrakaBhasma from "../../assets/ingridients-images/stamina/abhraka-bhasam.png";
import swarnaMakshik from "../../assets/ingridients-images/stamina/swarna-makshik.png";
import kasisBhasma from "../../assets/ingridients-images/stamina/kasis-bhasma.png";

const data = [
  {
    title: "Lauh Bhasma (AFI)",
    dosage: "120 mg",
    text: "Iron oxide for hemoglobin boost & energy support",
    image: lauhBhasma,
  },
  {
    title: "Mandur Bhasma",
    dosage: "180 mg",
    text: "Iron bark extract for strength & vitality",
    image: mandurBhasma,
  },
  {
    title: "Abhraka Bhasma",
    dosage: "100 mg",
    text: "Ferric oxide for mineral absorption & energy",
    image: abhrakaBhasma,
  },
  {
    title: "Swarna Makshik",
    dosage: "35 mg",
    text: "Calcium of gold for bone health & wellness",
    image: swarnaMakshik,
  },
  {
    title: "Kasis Bhasma",
    dosage: "45 mg",
    text: "Calcium sulphate for strong bones & teeth",
    image: kasisBhasma,
  },
];

const StaminaIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Premium Ayurvedic Ingredients for Bone & Iron Support
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img 
                src={item.image} 
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            </div>

            <div style={{
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#8b6f47',
              marginTop: '10px'
            }}>
              {item.dosage}
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StaminaIngredients;
